const enterpriseMonitoring = {
  namespaced: true,
  state: {
    monitoringCompanyNum: 0, //监控中企业个数
    needReRequest: 0, //列表页需要重新请求数据
    monitorPermission: false, //是否有权限
    showDialogNewFeatures: false, //是否弹功能介绍弹框
  },
  getters: {
    monitoringCompanyNum: (state) => state.monitoringCompanyNum,
    needReRequest: (state) => state.needReRequest,
    monitorPermission: (state) => state.monitorPermission,
    showDialogNewFeatures: (state) => state.showDialogNewFeatures,
  },
  mutations: {
    updateMonitoringCompanyNum(state, monitoringCompanyNum) {
      state.monitoringCompanyNum = monitoringCompanyNum;
    },
    updateNeedReRequest(state) {
      state.needReRequest = state.needReRequest + 1;
    },
    updateMonitorPermission(state, monitorPermission) {
      state.monitorPermission = monitorPermission;
    },
    updateShowDialogNewFeatures(state, showDialogNewFeatures) {
      state.showDialogNewFeatures = showDialogNewFeatures;
    },
  },
  actions: {},
};
export default enterpriseMonitoring;
